export default "__VITE_ASSET__L$FDcROg__"